import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface IAttachment extends IModelBase {
  name: string
}

export class Attachment extends ModelBase {
  name: string

  constructor(defaults?: IAttachment) {
    super(defaults)
    if (defaults) {
      this.id = defaults.id
      this.name = defaults.name
    }
  }

  toParams(): KeyPair {
    return {}
  }
}
